import {FieldConditions} from '../../../components/Forms/interface/form-conditions';

import {IConditionalVisibility} from './ICommon';

/* eslint-disable max-len */
export enum inputType {
  TEXT = 'text',
  ALPHANUMERIC = 'alphaNumeric',
  EMAIL = 'email',
  MOBILE = 'mobile',
  TEXTAREA = 'textarea',
  WYSIWYG = 'wysiwyg',
  SELECT = 'select',
  MULTISELECT = 'multiSelect',
  CITY = 'city',
  STATE = 'state',
  COUNTRY = 'country',
  NUMBER = 'number',
  RADIOGROUP = 'radioGroup',
  RADIOGROUP_GLAO_QUESTION_3 = 'radioGroupGlaoQuestion3',
  RADIOGROUP_YES_THEN_SHOW_TABLE = 'radioGroupIfYesThenShowTable',
  RADIOGROUP_NO_THEN_SHOW_TABLE = 'radioGroupIfNoThenShowTable',
  RADIOGROUP_IF_YES_THEN_TEXTAREA = 'radioGroupIfYesThenTextarea',
  RADIOGROUP_IF_YES_THEN_TEXTBOX = 'radioGroupIfYesThenTextbox',
  RADIOGROUP_IF_NO_THEN_TEXTBOX = 'radioGroupIfNoThenTextbox',
  CHECKBOX = 'checkbox',
  CHECKBOX_GLAO_QUESTION_40_TO_48 = 'checkboxGlaoQuestion40To48',
  CHECKBOX_NA_THEN_TEXTAREA = 'checkboxNAThenTextarea',
  CHECKBOXGROUP = 'checkboxGroup',
  DATEPICKER = 'datepicker',
  DATEPICKER_FINANCIAL_YEAR = 'datepickerFinancialYear',
  DATE_RANGE_PICKER = 'dateRangePicker',
  TIMEPICKER = 'timepicker',
  FILEUPLOAD = 'fileUpload',
  TABLE = 'table',
  ADD_MORE_FIELDS = 'addMoreFields',
  ADD_MORE_FIELDS_TOGGLE_TABLE = 'addMoreFieldsToggleTable',
  PERCENTAGE = 'percentage',
  HEADING = 'heading',
  HEADING_1 = 'heading_1',
  HEADING_2 = 'heading_2',
  HEADING_3 = 'heading_3',
  HEADING_4 = 'heading_4',
  HEADING_5 = 'heading_5',
  INPUT_GRID = 'inputGrid',
  DISPLAY = 'display',
  VERTICAL_DIVIDER = 'verticalDivider',
  ADD_NEW_TO_TABLE = 'addNewToTable',
  RADIOGROUP_IF_YES_ADDMORE_TEXTAREA = 'radioGroupYesAddMoreTextArea',
  ADDMORE_TEXTAREA = 'addMoreTextArea',
  TEXT_COL = 'textCol',
  TEXTAREA_COL = 'textAreaCol',
  NUMBER_COL = 'numberCol',
  GHG_EMISSIONS_REPORTING_10 = 'ghgEmissionReporting_10',
  ADD_FIXED_ROW_TO_TABLE = 'addFixedRowToTable',
  ADD_YEAR_FIXED_ROW_TO_TABLE = 'addYearFixedRowToTable',
  DISPLAY_CALCULATION_IN_TABLE = 'displayCalculationInTable',
  SELECT_WITH_OTHER_TEXTBOX = 'selectWithOtherTextBox',
  MULTISELECT_WITH_OTHER_TEXTBOX = 'multiSelectWithOtherTextBox'
}

export enum conditionType {
  EQUALS = 'equals',
  NOT = 'not',
  INCLUDES = 'includes',
  EMPTY = 'empty',
  NOT_EMPTY = 'not_empty',
  GREATER_THAN = 'greater_than',
  LESS_THAN = 'less_than',
  NOT_INCLUDES = 'not_includes'
}

export interface IField {
  dependsOn?: string;
  showWhen?: string | string[];
  relatedTableKey?: string;
  heading?: string;
  fieldType: string;
  fieldName: string;
  questionNo?: string;
  fieldLabel: string;
  textLimit?: number;
  askAIkey?: string;
  defaultValue?: any;
  placeHolder?: string;
  tooltip?: string;
  min?: number;
  max?: number;
  options?: any;
  fileUploadAction?: string;
  fileUploadValidExtensions?: any[];
  fileUploadMaxSize?: number;
  fileUploadAllowMultipleFiles?: boolean;
  yearsFrom?: number;
  tableStructure?: any;
  fieldStructure?: any;
  addMoreOption?: any;
  disabled?: boolean;
  pickerType?: any;
  dateFormat?: string;
  relatedKey?: string;
  formula?: (values: any[]) => number | string;
  triggerKey?: string;
  restrictFutureDateSelection?: boolean;
  useSelectedYear?: boolean;
  financialYearValidation?: boolean;
  relatedDateFieldName?: string; // For end date to reference start date
  convertToUpperCase?: boolean;
  selectionModeMultiple?: any;
  inputWidth?: any;
  disabledOn?: any;
  visibilityDependsOnField?: string;
  conditions?: FieldConditions;
  requiredOn?: any;
  isRequired?: boolean;
  exclusiveOption?: {value: string; message: string};
  units?: any;
  colSpan?: boolean;
  smallText?: boolean;
  roundTo?: number;
  isFormatted?: boolean;
  showOtherTextBox?: boolean;
  otherFieldName?: string;
  fixedRows?: any;
  rowId?: string;
  controlHeading?: {
    fieldType: inputType;
    heading?: string;
    tooltip?: string;
  };
  formList?: {
    name: string;
    // eslint-disable-next-line @typescript-eslint/array-type
    formFields: {
      type: string;
      fieldName: string;
      fieldLabel: string;
      placeHolder: string;
      options: any;
      heading: string;
      dateFormat?: string;
      relatedKey?: string;
      restrictFutureDateSelection?: boolean;
      fileUploadAction?: string;
      fileUploadValidExtensions?: any[];
      fileUploadMaxSize?: number;
      fileUploadAllowMultipleFiles?: boolean;
      units?: any;
      disabled?: boolean;
      showOtherTextBox?: boolean;
      otherFieldName?: string;
      askAIkey?: string;
    }[];
  };
  allowMultipleRows?: boolean;
  overflow?: string;
  formFields?: {
    fieldType: string;
    fieldName: string;
    fieldLabel: string;
    tooltip?: string;
    placeHolder?: string;
    options?: any;
    disabled?: boolean;
    fileUploadAction?: string;
    fileUploadValidExtensions?: any[];
    fileUploadMaxSize?: number;
    fileUploadAllowMultipleFiles?: boolean;
    disabledOn?: {
      fieldName: string;
      condition:
        | conditionType.EQUALS
        | conditionType.NOT
        | conditionType.INCLUDES
        | conditionType.EMPTY
        | conditionType.NOT_EMPTY
        | conditionType.GREATER_THAN;
      values?: string[];
      numericValue?: number;
    };
    conditions?: FieldConditions;
    requiredOn?: {
      fieldName: string;
      condition:
        | conditionType.EQUALS
        | conditionType.GREATER_THAN
        | conditionType.LESS_THAN
        | conditionType.INCLUDES;
      values?: string[];
      numericValue?: number;
      required?: boolean;
    };
  };
  formContent?: {
    // eslint-disable-next-line @typescript-eslint/array-type
    formFields: {
      type: string;
      fieldName: string;
      fieldLabel: string;
      placeHolder?: string;
      tooltip?: string;
      options: any;
      heading: string;
      dateFormat?: string;
      relatedKey?: string;
      restrictFutureDateSelection?: boolean;
      fileUploadAction?: string;
      fileUploadValidExtensions?: any[];
      fileUploadMaxSize?: number;
      fileUploadAllowMultipleFiles?: boolean;
      units?: any;
      askAIkey?: string;
      colSpan?: boolean;
      disabled?: boolean;
      disabledOn?: {
        fieldName: string;
        condition:
          | conditionType.EQUALS
          | conditionType.NOT
          | conditionType.INCLUDES
          | conditionType.EMPTY
          | conditionType.NOT_EMPTY
          | conditionType.GREATER_THAN;
        values?: string[];
        numericValue?: number;
      };
      conditions?: FieldConditions;
      requiredOn?: {
        fieldName: string;
        condition: conditionType.EQUALS | conditionType.INCLUDES;
        values?: string[];
        numericValue?: number;
        required?: boolean;
      };
      isFormatted?: boolean;
      showOtherTextBox?: boolean;
      otherFieldName?: string;
      formList?: {
        name: string;
        // eslint-disable-next-line @typescript-eslint/array-type
        formFields: {
          type: string;
          fieldName: string;
          fieldLabel: string;
          placeHolder: string;
          options: any;
          heading: string;
          dateFormat?: string;
          relatedKey?: string;
          restrictFutureDateSelection?: boolean;
          fileUploadAction?: string;
          fileUploadValidExtensions?: any[];
          fileUploadMaxSize?: number;
          fileUploadAllowMultipleFiles?: boolean;
          units?: any;
          disabled?: boolean;
          disabledOn?: {
            fieldName: string;
            condition:
              | conditionType.EQUALS
              | conditionType.NOT
              | conditionType.INCLUDES
              | conditionType.EMPTY
              | conditionType.NOT_EMPTY
              | conditionType.GREATER_THAN;
            values?: string[];
            numericValue?: number;
          };
          conditions?: FieldConditions;
          requiredOn?: {
            fieldName: string;
            condition: conditionType.EQUALS | conditionType.INCLUDES;
            values?: string[];
            numericValue?: number;
            required?: boolean;
          };
          showOtherTextBox?: boolean;
          otherFieldName?: string;
          askAIkey?: string;
        }[];
      };
    }[];
    // eslint-disable-next-line @typescript-eslint/array-type
    formCalculations?: {
      type: string;
      fieldName: string;
      fieldLabel: string;
      options: any;
      heading: string;
      tooltip?: string;
      dateFormat?: string;
      relatedKey?: string;
      restrictFutureDateSelection?: boolean;
      units?: any;
      formula: () => any;
      roundTo?: number;
    }[];
  };
  // eslint-disable-next-line @typescript-eslint/array-type
  fieldsListOnTriggerYes?: {
    fieldType: string;
    fieldName: string;
    fieldLabel: string;
    Question?: string;
    tooltip?: string;
    placeHolder?: string;
    disabled?: boolean;
  }[];
  fieldsOnTriggerNo?: {
    fieldType: string;
    fieldName: string;
    fieldLabel: string;
    Question?: string;
    tooltip?: string;
    placeHolder?: string;
    disabled?: boolean;
  };
  conditionalVisibility?: IConditionalVisibility;
  multipleConditionalVisibility?: IConditionalVisibility[];
  isConditionallyVisible?: boolean; // Internal flag to track visibility state
  validationData?: any;
  refreshControl?: boolean;
  errorMessage?: string;
  errorMessageCondition?: {
    condition: conditionType.GREATER_THAN | conditionType.LESS_THAN;
    numericValue: number;
  };
  customFixedRowsBasedOnDependency?: {
    dependentFieldName: string;
    dependencies?: any[];
    checkDependency: (
      source: any,
      targetSource?: any,
      currentFixedRows?: any[]
    ) => any;
  };
  yearFixedRowsBasedOnDependency?: {
    yearFieldName: string; // Year column in formList, its options drive the fixed rows
    pastYearsFieldName: string; // Yes/No - providing data for past reporting years
    pastYearsCountFieldName: string; // Number of past reporting years (e.g. '3 years')
    excludeReportingYear?: boolean; // Only past year rows, without the reporting year row
  };
  autoPopulate?: boolean;
}
